import { useState, useCallback } from 'react';
import { UtilsController } from '../core';

const useUtils = () => {
  const [refreshKey, setRefreshKey] = useState(0);

  const refreshEvents = useCallback(() => {
    setRefreshKey(prev => prev + 1);
  }, []);

  const copyToClipboard = useCallback(async (text) => {
    return await UtilsController.copyToClipboard(text);
  }, []);

  const downloadQRImage = useCallback((qrCodeImage, eventTitle) => {
    return UtilsController.downloadQRImage(qrCodeImage, eventTitle);
  }, []);

  const downloadFile = useCallback((url, filename) => {
    return UtilsController.downloadFile(url, filename);
  }, []);

  const showNotification = useCallback((message, type = 'info') => {
    UtilsController.showNotification(message, type);
  }, []);

  return {
    // State
    refreshKey,
    
    // Actions
    refreshEvents,
    copyToClipboard,
    downloadQRImage,
    downloadFile,
    showNotification
  };
};

export default useUtils;